import React from "react";

export default function showDollarPerUnit(quantity) {
  return <span>
    x {quantity}
  </span>
};